import React, { useContext } from "react";
import { HoverNavBar, TopNavBar } from "../navbars";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  makeStyles,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";

import { AlertProps, AxiosCall, extractIdAndValue } from "../../utils";
import Config from "../../config";
import { CommonTable, VerticalList } from "../common";
import { ServiceTypeConfig } from "./serviceTypeConfig";
import { EnvContext } from "../../contexts";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  addBtn: {
    float: "right",
    fontSize: "14px",
    fontWeight: 600,
  },
  content: {
    width: "98%",
    height: "calc(100vh - 64px)",
    overflow: "auto",
    [theme.breakpoints.up("sm")]: {
      paddingLeft: 56,
    },
    [theme.breakpoints.down("sm")]: {
      paddingLeft: 0,
    },
    marginTop: "70px",
    marginLeft: "30px",
  },
  topNavbar: {},
  sideNavbar: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  hovarNavBar: {
    display: "flex",
    position: "relative",
    top: "63px",
  },
}));
const styles = {
  outlinedButton: {
    borderColor: "#DEDEDE",
    color: "#2A60BC",
    backgroundColor: "#fff",
    borderRadius: 8,
    fontSize: 14,
    fontFamily: "pc_regular !important",
    display: "block",
    whiteSpace: "nowrap",
  },
  outlinedDelButton: {
    borderColor: "#FF4D4A",
    color: "#FF4D4A",
    backgroundColor: "#fff",
    borderRadius: 8,
    fontSize: 14,
    fontFamily: "pc_regular !important",
    display: "block",
    whiteSpace: "nowrap",
  },
  modalHeading: {
    fontSize: 16,
    color: "#2A60BC",
    // marginBottom: 10,
  },
};

export const ServiceTypeConfigList = (props) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  // -------state---------
  const [isFormOpen, setisFormOpen] = React.useState({
    isForm: false,
    isEdit: false,
    isView: false,
  });
  const [state, setState] = React.useState();
  const [facts, setFacts] = React.useState([]);
  const [factType, setFactType] = React.useState([]);
  const [filterVal, setFilterVal] = React.useState();
  const classes = useStyles({ props });
  const [editState, setEditState] = React.useState({
    edit: false,
    editState: {},
  });
  const { envConfig } = useContext(EnvContext);
  const [openAlert, setOpenAlert] = React.useState({
    open: false,
    index: null,
  });
  // --------events--------
  const getFacts = async (pageDetails, searchVal = "", filterVal) => {
    try {
      let payload = {
        db_name: envConfig.REACT_APP_DATABASE_NAME,
        queryid: "7da281aa-8439-4d92-b862-d7b5e1bc7e2f",
        filter: {
          serachvalue: searchVal ?? "",
          page: pageDetails?.page ?? 0,
          perPage: pageDetails?.perPage ?? 10,
        },
      };
      let Resp = await AxiosCall(
        payload,
        envConfig.REACT_APP_READ_QDM_QUERY
      );
      if (Resp) {
        setFacts(Resp);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const getFactsData = async (row, index) => {
    try {
      let getRec = facts[index];
      setEditState({
        edit: true,
        editState: getRec,
      });
    } catch (e) {
      console.error(e, "error on single read");
    }
  };
  const handleEdit = (e, row, index) => {
    getFactsData(row, index);
    setisFormOpen({
      isForm: false,
      isEdit: true,
      isView: false,
    });
  };

  const handlePageChange = async (currentPage, PerPage) => {
    if (PerPage) {
      setState({
        page: (currentPage - 1) * PerPage,
        perPage: PerPage,
      });
      await getFacts({ page: (currentPage - 1) * PerPage, perPage: PerPage });
    }
  };
  const handleDelete = async (del) => {
    try {
      if (del?.open) {
        let deleteData = facts[del?.index];
        let delPayload = {
          db_name: envConfig.REACT_APP_DATABASE_NAME,
          entity: Config.LeadServiceTypeConfig,
          filter: `${Config.LeadServiceTypeConfig}._id == '${deleteData?._id}'`,
          metadata_dbname: envConfig.REACT_APP_MetadataDB_Name,
        };
        let Resp = await AxiosCall(
          delPayload,
          envConfig.REACT_APP_SOFT_DELETE
        );
        if (Resp) {
          setOpenAlert({
            ...openAlert,
            open: false,
            index: null,
          });
          if (Resp?.Code === 201) {
            getFacts();
            alert?.setSnack({
              open: true,
              severity: AlertProps.severity.success,
              msg: "Deleted Successfully",
              vertical: AlertProps.vertical.top,
              horizontal: AlertProps.horizontal.right,
              tone: true,
            });
          } else {
            alert?.setSnack({
              open: true,
              severity: AlertProps.severity.error,
              msg: "Delete Failed",
              vertical: AlertProps.vertical.top,
              horizontal: AlertProps.horizontal.right,
              tone: true,
            });
          }
        } else {
          alert?.setSnack({
            open: true,
            severity: AlertProps.severity.error,
            msg: "please contact admin",
            vertical: AlertProps.vertical.top,
            horizontal: AlertProps.horizontal.right,
            tone: true,
          });
        }
      }
    } catch (e) {
      console.error(e);
    }
  };
  const handleView = (e, row, index) => {
    getFactsData(row, index);
    setisFormOpen({
      isForm: false,
      isEdit: false,
      isView: true,
    });
  };
  const handleSearch = (searchVal) => {
    setFilterVal({
      ...filterVal,
      search: searchVal,
    });
    getFacts("", searchVal, filterVal?.facttype);
  };
  const onFilterChange = (key, e, val) => {
    setFilterVal({
      ...filterVal,
      facttype: val,
    });
    getFacts("", filterVal?.search, val);
  };
  const getFactType = async () => {
    try {
      let payload = {
        db_name: envConfig.REACT_APP_DATABASE_NAME,
        filter: {
          type: ["FACTTYPE"],
          tenantid: envConfig.REACT_APP_TENANTID,
          facilityid: "",
          lang: "en",
        },
        queryid: envConfig.REACT_APP_RULE_BUILDER_FACT_GM,
      };
      let Resp = await AxiosCall(
        payload,
        envConfig.REACT_APP_READ_QDM_QUERY
      );
      if (Resp) {
        let result = await extractIdAndValue("FACTTYPE", Resp);
        setFactType(result);
      }
    } catch (e) {
      console.error(e);
    }
  };
  // ---------Life Cycle Hooks--------
  React.useEffect(() => {
    getFacts();
    getFactType();
  }, []);

  return (
    <div className={classes.root}>
      {/* Your nav bars here */}
      <div className={classes.topNavbar}>
        <TopNavBar />
      </div>
      {/* Your hovar bars here */}

      <div className={classes.hovarNavBar}>
        <HoverNavBar />
      </div>

      <div className={classes.content}>
        {isFormOpen?.isForm || isFormOpen?.isEdit || isFormOpen?.isView ? (
          <ServiceTypeConfig
            isFormOpen={isFormOpen}
            setisFormOpen={setisFormOpen}
            getFacts={getFacts}
            editState={editState}
            setEditState={setEditState}
          />
        ) : (
          <VerticalList
            parent_id={"consult_master"}
            addFunc={() =>
              setisFormOpen({ isForm: true, isEdit: false, isView: false })
            }
            id={"referalrights"}
            placeholder={"search code & description"}
            onSearchChange={handleSearch}
            hideSearchBar={false}
            // hideFilter={true}
            // showFilterDropDown={true}
            // FilterTitle={"Fact Type"}
            // filterList={factType}
            // onFilterChange={onFilterChange}
            // onFilterClicked={props?.onFilterClicked}
            // isFilterApplied={props?.isFilterApplied}

            TabList={[
              {
                name: "Service Type Configuration",
                component: (
                  <CommonTable
                    parent_id={"consult_master"}
                    rightAlign={["View", "Action"]}
                    handleEdit={handleEdit}
                    handleView={handleView}
                    handleDelete={(e, v, i) =>
                      setOpenAlert({
                        open: true,
                        index: i,
                      })
                    }
                    // handleCheckBox={handleCheckBox}
                    Header={[
                      { label: "S.No", showSort: false, showFilter: false },
                      { label: "Code", showSort: false, showFilter: false },
                      {
                        label: "Service Type",
                        showSort: false,
                        showFilter: false,
                      },
                      {
                        label: "Is Clinical",
                        showSort: false,
                        showFilter: false,
                      },
                      { label: "Action", showSort: false, showFilter: false },
                      { label: "View", showSort: false, showFilter: false },
                    ]}
                    dataList={facts ?? []}
                    tableData={[
                      { type: ["INCRIMENT"], name: "1" },
                      { type: ["TEXT"], name: "servicecode" },
                      //   { type: ["TEXT"], name: "factname" },
                      { type: ["TEXT"], name: "servicename" },
                      { type: ["TEXT"], name: "isclinicaltext" },
                      // {
                      //   type: ["TEXT"],
                      //   name: "isclinicalassment",
                      // },
                      { type: ["EDIT", "DELETE"], name: "", align: "right" },
                      { type: ["VIEW"], name: "", align: "right" },
                    ]}
                    handlepageChange={(currentPage, PerPage) =>
                      handlePageChange(currentPage, PerPage)
                    }
                    TableCount={facts?.[0]?.totalcount}
                    incrementCount={state?.page}
                    showPagination={true}
                    rowsPerPageOptions={[
                      { label: "10 Rows", value: 10 },
                      { label: "50 Rows", value: 50 },
                      { label: "100 Rows", value: 100 },
                    ]}
                  />
                ),
              },
            ]}
          />
        )}
      </div>
      {openAlert?.open && (
        <Dialog
          fullScreen={fullScreen}
          open={openAlert?.open}
          onClose={() =>
            setOpenAlert({
              ...openAlert,
              open: false,
            })
          }
          aria-labelledby="alert-dialog-title"
        >
          <DialogTitle style={styles.modalHeading} id="alert-dialog-title">
            {"Are you Sure Want to Delete ?"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Are you sure you want to delete this record? This action cannot be
              undone.
            </DialogContentText>
          </DialogContent>
          <DialogActions style={{ padding: "15px" }}>
            <Button
              onClick={() =>
                setOpenAlert({
                  ...openAlert,
                  open: false,
                })
              }
              color="primary"
              style={styles.outlinedButton}
              variant="contained"
            >
              No
            </Button>
            <Button
              onClick={() => handleDelete(openAlert)}
              color="primary"
              style={styles.outlinedDelButton}
              variant="contained"
            >
              Yes
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </div>
  );
};
